import { AxiosPrivate } from '../../utils';

export interface ICollectionData {
  id: number;
  stage: string;
  type: 'Collection';
}
export interface IExemplarData {
  id: number;
  page: string;
  stage: string;
  type: 'Exemplar';
}
export interface ILessonData {
  id: number;
  pageId: number;
  collectionId: number;
  exemplarsRelated: number;
  textType: number;
  type: 'Lesson';
}

interface IShortUrlData {
  data: ICollectionData | IExemplarData | ILessonData;
}

class ShortUrlAPI {
  private static instance: ShortUrlAPI;

  public static getInstance(): ShortUrlAPI {
    if (!ShortUrlAPI.instance) {
      ShortUrlAPI.instance = new ShortUrlAPI();
    }
    return ShortUrlAPI.instance;
  }

  getShortUrl = (code: string) => {
    return AxiosPrivate.get<IShortUrlData>(`/v1/shorturl/${code}`);
  };
}

export const shortUrlAPI = ShortUrlAPI.getInstance();
